import { render, staticRenderFns } from "./UserCertificate.vue?vue&type=template&id=a8c8ccb8&scoped=true&"
import script from "./UserCertificate.vue?vue&type=script&lang=js&"
export * from "./UserCertificate.vue?vue&type=script&lang=js&"
import style0 from "./UserCertificate.vue?vue&type=style&index=0&id=a8c8ccb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c8ccb8",
  null
  
)

export default component.exports